import "./whatGPT3.css";

const WhatGPT3 = () => {
  return (
    <div className="wgpt3 section__margin" id="wgpt3">
      <div className="wgpt3-feature">
        <div className="wgpt3-feature-title">
          <div className="wgpt3-line"></div>
          <h1>What is GPT-3</h1>
        </div>
        <div className="wgpt3-feature-text">
          <p>
            We so opinion friends me message as delight. Whole front do of plate heard oh ought.
            His defective nor convinced residence own. Connection has put impossible own apartments 
            boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance 
            to on by.
          </p>
        </div>
      </div>

      <div className="wgpt3-heading">
        <h1 className="gradient-text">The possibilities are beyond your imagination</h1>
        <p>Explore The Library</p>
      </div>

      <div className="wgpt3-container">
        <div className="wgpt3-item">
          <div className="wgpt3-line"></div>
          <h1>Chatbots</h1>
          <p>
            We so opinion friends me message as delight. Whole front do of plate heard oh ought.
          </p>
        </div>

        <div className="wgpt3-item">
          <div className="wgpt3-line"></div>
          <h1>Knowledgebase</h1>
          <p>
            At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by.
            As put impossible own apartments b
          </p>
        </div>

        <div className="wgpt3-item">
          <div className="wgpt3-line"></div>
          <h1>Education</h1>
          <p>
            At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by.
            As put impossible own apartments b
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhatGPT3;
